// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Page ── */
.product-detail-page {
  min-height: 100vh;
  background: #f0f0f0;
  font-family: "Gilroy", sans-serif;
}

.detail-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 36px 20px 60px;
}

/* ── Product Detail Card (wrapper) ── */
.pd-card {
  background: white;
  border-radius: 22px;
  overflow: hidden;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.08);
  margin-bottom: 30px;
}

/* ── Main Grid: image | details ── */
.product-detail-grid {
  display: grid;
  grid-template-columns: 55% 45%;
  min-height: 580px;
}

/* ── LEFT: Image Showcase ── */
.product-showcase {
  display: flex;
  flex-direction: row;
  overflow: hidden;
  border-right: 1px solid #f0f0f0;
}

/* Vertical thumbnails */
.thumbnails-col {
  width: 92px;
  padding: 20px 10px 20px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-right: 1px solid #f2f2f2;
  overflow-y: auto;
  scrollbar-width: none;
  flex-shrink: 0;
}

.thumbnails-col::-webkit-scrollbar { display: none; }

.thumbnail {
  width: 66px;
  height: 66px;
  border-radius: 10px;
  border: 2px solid transparent;
  overflow: hidden;
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.2s;
  background: #f5f5f5;
}

.thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.thumbnail:hover { border-color: #ddd; }

.thumbnail.active {
  border-color: #ed2b91;
  box-shadow: 0 0 0 2px rgba(237, 43, 145, 0.15);
}

.thumb-more-btn {
  text-align: center;
  font-size: 1.1rem;
  color: #aaa;
  cursor: pointer;
  padding: 4px 0;
  -webkit-user-select: none;
          user-select: none;
}

/* Main image area */
.showcase-image {
  flex: 1 1;
  position: relative;
  overflow: hidden;
  background: #fafafa;
  display: flex;
  align-items: center;
  justify-content: center;
}

.main-product-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* Zoom button */
.zoom-btn {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 38px;
  height: 38px;
  background: white;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.12);
  z-index: 5;
  transition: transform 0.2s;
  color: #444;
}

.zoom-btn:hover { transform: scale(1.08); }

/* Nav arrows */
.image-navigation {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  padding: 0 14px;
  z-index: 5;
}

.nav-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.92);
  border: none;
  font-size: 1.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.12);
  transition: all 0.2s;
  color: #222;
  line-height: 1;
}

.nav-btn:hover {
  background: white;
  transform: scale(1.08);
}

/* Dots */
.image-dots {
  position: absolute;
  bottom: 14px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 6px;
  z-index: 5;
}

.dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.25);
  cursor: pointer;
  transition: all 0.2s;
}

.dot.active {
  background: #222;
  width: 18px;
  border-radius: 4px;
}

.showcase-icon {
  font-size: 100px;
  opacity: 0.3;
}

/* Frame styles */
.frame-preview-container {
  background: linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%);
}

.frame-with-photo {
  width: 75%;
  height: 80%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 12px solid #222;
  box-shadow: inset 0 0 20px rgba(0,0,0,0.5), 0 10px 30px rgba(0,0,0,0.3);
  position: relative;
  border-radius: 4px;
}

.frame-photo-preview {
  width: calc(100% - 40px);
  height: calc(100% - 40px);
  object-fit: cover;
  border-radius: 2px;
}

/* ── RIGHT: Product Details ── */
.product-details {
  padding: 36px 36px 36px 36px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.product-category-label {
  display: block;
  font-size: 0.82rem;
  font-weight: 700;
  color: #ed2b91;
  margin-bottom: 10px;
  letter-spacing: 0.3px;
}

.detail-title {
  font-size: 2rem;
  font-weight: 900;
  color: #111;
  margin: 0 0 12px;
  line-height: 1.2;
}

.detail-description {
  font-size: 0.92rem;
  color: #666;
  line-height: 1.65;
  margin: 0 0 22px;
}

/* Features + Price side by side */
.features-price-row {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  margin-bottom: 24px;
}

.features-list {
  flex: 1 1;
}

.features-list h3 {
  font-size: 0.92rem;
  font-weight: 800;
  color: #111;
  margin: 0 0 10px;
}

.features-list ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.features-list li {
  font-size: 0.88rem;
  color: #444;
  display: flex;
  align-items: center;
  gap: 8px;
  padding-left: 2px;
}

.features-list li::before {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #ed2b91;
  flex-shrink: 0;
}

/* Price box */
.price-box {
  background: #f5f5f5;
  border-radius: 14px;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  min-width: 130px;
  flex-shrink: 0;
}

.price-label {
  font-size: 0.8rem;
  color: #999;
  margin-bottom: 4px;
  white-space: nowrap;
}

.price-value {
  font-size: 2rem;
  font-weight: 900;
  color: #111;
  line-height: 1;
}

.original-price-strike {
  font-size: 0.85rem;
  color: #bbb;
  text-decoration: line-through;
  margin-top: 4px;
}

/* ── Page Selection ── */
.page-selection-inline {
  margin-bottom: 20px;
}

.page-selection-title {
  font-size: 0.92rem;
  font-weight: 800;
  color: #111;
  margin: 0 0 12px;
}

.page-options-inline {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.page-option-btn {
  background: white;
  border: 1.5px solid #e2e2e2;
  border-radius: 12px;
  padding: 14px 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 12px;
  transition: border-color 0.2s;
  text-align: left;
  font-family: "Gilroy", sans-serif;
}

.page-option-btn:hover { border-color: #ed2b91; }

.page-option-btn.active {
  border-color: #ed2b91;
  border-width: 2px;
}

.option-radio-circle {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #ddd;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: border-color 0.2s;
}

.page-option-btn.active .option-radio-circle { border-color: #ed2b91; }

.option-radio-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #ed2b91;
}

.option-texts {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.option-label {
  font-size: 0.88rem;
  font-weight: 700;
  color: #111;
}

.option-extra {
  font-size: 0.8rem;
  color: #888;
}

/* ── Design Button ── */
.design-btn {
  width: 100%;
  background: #1a1a1a;
  color: white;
  border: none;
  padding: 17px 24px;
  border-radius: 14px;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition: background 0.2s;
  font-family: "Gilroy", sans-serif;
  margin-top: 20px;
  box-shadow: none;
  height: auto;
  max-width: 100%;
}

.design-btn:hover { background: #333; transform: none; }
.design-btn:active { transform: none; }

.add-to-cart-btn {
  width: 100%;
  background: white;
  color: #1a1a1a;
  border: 1.5px solid #1a1a1a;
  padding: 15px 24px;
  border-radius: 14px;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  font-family: "Gilroy", sans-serif;
  margin-top: 12px;
  transition: background 0.2s, color 0.2s;
}

.add-to-cart-btn:hover { background: #1a1a1a; color: white; }

.add-to-cart-btn:disabled {
  background: #f0f0f0;
  color: #909090;
  border-color: #d4d4d4;
  cursor: default;
}

.btn-arrow { font-size: 1.15rem; }

/* Security text */
.security-text {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  font-size: 0.82rem;
  color: #999;
  margin-top: 12px;
}

/* Kitchen note */
.kitchen-personalization-note {
  background: #f8f4ee;
  border-left: 3px solid #2d3748;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 14px;
  color: #2d3748;
  font-weight: 500;
  margin-bottom: 8px;
}

/* ── Upload sections ── */
.upload-section {
  margin-top: 20px;
}

.option-title {
  font-size: 1rem;
  font-weight: 700;
  color: #111;
  margin: 0 0 14px;
}

.frame-upload-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}

.frame-upload-btn {
  background: #1a1a1a;
  color: white;
  padding: 13px 28px;
  border-radius: 50px;
  font-size: 0.92rem;
  font-weight: 700;
  cursor: pointer;
  display: inline-block;
  transition: background 0.2s;
}

.frame-upload-btn:hover { background: #333; }

.upload-hint {
  font-size: 0.82rem;
  color: #aaa;
  margin: 0;
}

.order-btn {
  width: 100%;
  background: #1a1a1a;
  color: white;
  border: none;
  padding: 17px 24px;
  border-radius: 14px;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition: background 0.2s, transform 0.2s;
  font-family: "Gilroy", sans-serif;
  margin-top: 20px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.18);
}

.order-btn:hover:not(:disabled) { background: #333; }
.order-btn:active:not(:disabled) { transform: scale(0.98); }

/* Uploaded images */
.uploaded-images { margin-top: 20px; }

.uploaded-images h4 {
  font-size: 0.95rem;
  font-weight: 700;
  color: #111;
  margin: 0 0 14px;
}

.images-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 10px;
}

.image-preview {
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  background: #f5f5f5;
}

.image-preview img {
  width: 100%;
  height: 110px;
  object-fit: cover;
  display: block;
}

.remove-image-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  background: rgba(0, 0, 0, 0.55);
  color: white;
  border: none;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}

.remove-image-btn:hover { background: rgba(0, 0, 0, 0.8); }

.image-name {
  padding: 6px 8px;
  font-size: 0.72rem;
  color: #666;
  background: white;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ── Customization / Related Products ── */
.customization-section {
  background: white;
  border-radius: 20px;
  padding: 36px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
}

.section-heading {
  font-size: 1.8rem;
  font-weight: 900;
  color: #111;
  margin: 0 0 30px;
  text-align: center;
}

.option-group { margin-bottom: 30px; }

.book-store-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 18px;
  margin-top: 16px;
}

.book-card {
  background: white;
  border: 1px solid #ebebeb;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  flex-direction: column;
}

.book-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.1);
}

.book-image-container {
  width: 100%;
  height: 240px;
  /* background: #f5f5f5; */
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
}

.book-image {
  width: 160px;
  height: auto;
  object-fit: cover;
  transition: transform 0.3s;
}

.book-card:hover .book-image { transform: scale(1.05); }

.book-placeholder { font-size: 50px; opacity: 0.25; }

.book-discount-badge {
  position: absolute;
  top: 10px;
  left: 10px;
  background: #ed2b91;
  color: white;
  font-size: 0.72rem;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 20px;
}

.book-info {
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex-grow: 1;
}

.book-title {
  font-size: 0.95rem;
  font-weight: 700;
  color: #111;
  margin: 0;
  line-height: 1.3;
}

.book-subtitle {
  font-size: 0.82rem;
  color: #888;
  margin: 0;
  line-height: 1.3;
}

.book-pricing {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.book-current-price {
  font-size: 1.15rem;
  font-weight: 900;
  color: #111;
}

.book-original-price {
  font-size: 0.82rem;
  color: #bbb;
  text-decoration: line-through;
}

.book-discount-label {
  font-size: 0.78rem;
  font-weight: 700;
  color: #ed2b91;
  background: rgba(237, 43, 145, 0.08);
  padding: 2px 7px;
  border-radius: 10px;
}

.book-details-btn {
  width: 100%;
  background: #1a1a1a;
  color: white;
  border: none;
  padding: 10px 14px;
  border-radius: 8px;
  font-weight: 700;
  font-size: 0.8rem;
  cursor: pointer;
  transition: background 0.2s;
  letter-spacing: 0.5px;
  margin-top: auto;
}

.book-details-btn:hover { background: #333; }

/* ── Not found ── */
.not-found {
  text-align: center;
  padding: 100px 20px;
  font-size: 1.5rem;
  color: #888;
}

/* ── Animations ── */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(16px); }
  to { opacity: 1; transform: translateY(0); }
}

/* ── Responsive: Tablet ── */
@media (max-width: 900px) {
  .product-detail-grid {
    grid-template-columns: 1fr;
  }

  .product-showcase {
    border-right: none;
    border-bottom: 1px solid #f0f0f0;
    height: 400px;
  }

  .thumbnails-col {
    width: 76px;
    padding: 14px 8px 14px 12px;
  }

  .thumbnail {
    width: 56px;
    height: 56px;
  }

  .product-details {
    padding: 28px 24px;
  }

  .detail-title { font-size: 1.6rem; }
  .price-value { font-size: 1.7rem; }
}

/* ── Responsive: Mobile ── */
@media (max-width: 640px) {
  .detail-container {
    padding: 0 0 40px;
  }

  /* Product card flush to edges on mobile */
  .pd-card {
    border-radius: 0;
    box-shadow: none;
    border-bottom: 1px solid #e8e8e8;
    margin-bottom: 16px;
  }

  /* Stack: image on top, thumbnails horizontal below */
  .product-showcase {
    flex-direction: column;
    height: auto;
    border-bottom: 1px solid #f0f0f0;
  }

  /* Main image area */
  .showcase-image {
    width: 100%;
    height: 300px;
    background: #fff;
  }

  /* Image fits fully without cropping */
  .main-product-image {
    object-fit: contain;
    padding: 35px;
  }

  /* Thumbnails become horizontal strip below image */
  .thumbnails-col {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: auto;
    padding: 10px 14px;
    border-right: none;
    border-top: 1px solid #f2f2f2;
    overflow-x: auto;
    overflow-y: visible;
    gap: 8px;
  }

  .thumbnail {
    width: 58px;
    height: 58px;
    flex-shrink: 0;
  }

  /* Details section */
  .product-details {
    padding: 22px 18px 28px;
  }

  .product-category-label {
    font-size: 0.8rem;
    margin-bottom: 6px;
  }

  .detail-title {
    font-size: 1.55rem;
    margin-bottom: 10px;
  }

  .detail-description {
    font-size: 0.88rem;
    margin-bottom: 18px;
  }

  /* Features + Price stack vertically */
  .features-price-row {
    flex-direction: column;
    gap: 14px;
    margin-bottom: 20px;
  }

  .features-list h3 {
    font-size: 0.9rem;
    margin-bottom: 8px;
  }

  .features-list li {
    font-size: 0.86rem;
  }

  /* Price box full width */
  .price-box {
    align-items: flex-start;
    width: 100%;
    padding: 14px 16px;
    flex-direction: row;
    align-items: center;
    gap: 12px;
  }

  .price-label {
    font-size: 0.82rem;
    margin-bottom: 0;
  }

  .price-value {
    font-size: 1.8rem;
  }

  /* Page selection */
  .page-selection-title {
    font-size: 0.9rem;
    margin-bottom: 10px;
  }

  .page-options-inline {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .page-option-btn {
    padding: 13px 14px;
  }

  .option-label { font-size: 0.88rem; }
  .option-extra { font-size: 0.78rem; }

  /* Design button */
  .design-btn {
    padding: 16px 20px;
    font-size: 0.97rem;
    border-radius: 12px;
    margin-top: 16px;
  }

  .order-btn {
    padding: 16px 20px;
    font-size: 0.97rem;
    border-radius: 12px;
    margin-top: 16px;
  }

  .security-text {
    font-size: 0.8rem;
    margin-top: 10px;
  }

  /* Nav arrows smaller on mobile */
  .nav-btn {
    width: 34px;
    height: 34px;
    font-size: 1.3rem;
  }

  /* Customization section */
  .customization-section {
    border-radius: 0;
    padding: 24px 16px;
    box-shadow: none;
  }

  .section-heading {
    font-size: 1.3rem;
    margin-bottom: 20px;
  }

  .book-store-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }

  .book-image-container { height: 160px; }

  .book-image { width: 120px; }

  .book-info { padding: 10px; gap: 4px; }

  .book-title { font-size: 0.85rem; }

  .book-subtitle { font-size: 0.75rem; }

  .current-price { font-size: 1rem; }

  .book-details-btn {
    font-size: 0.75rem;
    padding: 8px 10px;
  }

  /* Upload section */
  .frame-upload-btn {
    padding: 12px 22px;
    font-size: 0.88rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ProductDetail.css"],"names":[],"mappings":"AAAA,eAAe;AACf;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA,wCAAwC;AACxC;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,+BAA+B;EAC/B,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,qCAAqC,aAAa,EAAE;;AAEpD;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,mBAAmB,kBAAkB,EAAE;;AAEvC;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0CAA0C;EAC1C,UAAU;EACV,0BAA0B;EAC1B,WAAW;AACb;;AAEA,kBAAkB,sBAAsB,EAAE;;AAE1C,eAAe;AACf;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0CAA0C;EAC1C,oBAAoB;EACpB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,6DAA6D;AAC/D;;AAEA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,uEAAuE;EACvE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,6BAA6B;EAC7B,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,6BAA6B;EAC7B,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA,yBAAyB,qBAAqB,EAAE;;AAEhD;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,6BAA6B;AAC/B;;AAEA,+CAA+C,qBAAqB,EAAE;;AAEtE;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,2BAA2B;EAC3B,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA,oBAAoB,gBAAgB,EAAE,eAAe,EAAE;AACvD,qBAAqB,eAAe,EAAE;;AAEtC;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA,yBAAyB,mBAAmB,EAAE,YAAY,EAAE;;AAE5D;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;;AAEA,aAAa,kBAAkB,EAAE;;AAEjC,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA,0BAA0B,gBAAgB,EAAE;;AAE5C;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,2CAA2C;EAC3C,iCAAiC;EACjC,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA,kCAAkC,gBAAgB,EAAE;AACpD,mCAAmC,sBAAsB,EAAE;;AAE3D,oBAAoB;AACpB,mBAAmB,gBAAgB,EAAE;;AAErC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,+BAA+B;EAC/B,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA,0BAA0B,8BAA8B,EAAE;;AAE1D;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,2CAA2C;AAC3C;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,gBAAgB,mBAAmB,EAAE;;AAErC;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA,+BAA+B,sBAAsB,EAAE;;AAEvD,oBAAoB,eAAe,EAAE,aAAa,EAAE;;AAEpD;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,2BAA2B;EAC3B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,0BAA0B,gBAAgB,EAAE;;AAE5C,oBAAoB;AACpB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA,6BAA6B;AAC7B;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;IAChC,aAAa;EACf;;EAEA;IACE,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA,gBAAgB,iBAAiB,EAAE;EACnC,eAAe,iBAAiB,EAAE;AACpC;;AAEA,6BAA6B;AAC7B;EACE;IACE,iBAAiB;EACnB;;EAEA,0CAA0C;EAC1C;IACE,gBAAgB;IAChB,gBAAgB;IAChB,gCAAgC;IAChC,mBAAmB;EACrB;;EAEA,qDAAqD;EACrD;IACE,sBAAsB;IACtB,YAAY;IACZ,gCAAgC;EAClC;;EAEA,oBAAoB;EACpB;IACE,WAAW;IACX,aAAa;IACb,gBAAgB;EAClB;;EAEA,sCAAsC;EACtC;IACE,mBAAmB;IACnB,aAAa;EACf;;EAEA,mDAAmD;EACnD;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,6BAA6B;IAC7B,gBAAgB;IAChB,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA,oBAAoB;EACpB;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA,sCAAsC;EACtC;IACE,sBAAsB;IACtB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA,yBAAyB;EACzB;IACE,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,mBAAmB;EACnB;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;IACE,kBAAkB;EACpB;;EAEA,gBAAgB,kBAAkB,EAAE;EACpC,gBAAgB,kBAAkB,EAAE;;EAEpC,kBAAkB;EAClB;IACE,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA,iCAAiC;EACjC;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA,0BAA0B;EAC1B;IACE,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA,wBAAwB,aAAa,EAAE;;EAEvC,cAAc,YAAY,EAAE;;EAE5B,aAAa,aAAa,EAAE,QAAQ,EAAE;;EAEtC,cAAc,kBAAkB,EAAE;;EAElC,iBAAiB,kBAAkB,EAAE;;EAErC,iBAAiB,eAAe,EAAE;;EAElC;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA,mBAAmB;EACnB;IACE,kBAAkB;IAClB,kBAAkB;EACpB;AACF","sourcesContent":["/* ── Page ── */\n.product-detail-page {\n  min-height: 100vh;\n  background: #f0f0f0;\n  font-family: \"Gilroy\", sans-serif;\n}\n\n.detail-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 36px 20px 60px;\n}\n\n/* ── Product Detail Card (wrapper) ── */\n.pd-card {\n  background: white;\n  border-radius: 22px;\n  overflow: hidden;\n  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.08);\n  margin-bottom: 30px;\n}\n\n/* ── Main Grid: image | details ── */\n.product-detail-grid {\n  display: grid;\n  grid-template-columns: 55% 45%;\n  min-height: 580px;\n}\n\n/* ── LEFT: Image Showcase ── */\n.product-showcase {\n  display: flex;\n  flex-direction: row;\n  overflow: hidden;\n  border-right: 1px solid #f0f0f0;\n}\n\n/* Vertical thumbnails */\n.thumbnails-col {\n  width: 92px;\n  padding: 20px 10px 20px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  border-right: 1px solid #f2f2f2;\n  overflow-y: auto;\n  scrollbar-width: none;\n  flex-shrink: 0;\n}\n\n.thumbnails-col::-webkit-scrollbar { display: none; }\n\n.thumbnail {\n  width: 66px;\n  height: 66px;\n  border-radius: 10px;\n  border: 2px solid transparent;\n  overflow: hidden;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: all 0.2s;\n  background: #f5f5f5;\n}\n\n.thumbnail img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.thumbnail:hover { border-color: #ddd; }\n\n.thumbnail.active {\n  border-color: #ed2b91;\n  box-shadow: 0 0 0 2px rgba(237, 43, 145, 0.15);\n}\n\n.thumb-more-btn {\n  text-align: center;\n  font-size: 1.1rem;\n  color: #aaa;\n  cursor: pointer;\n  padding: 4px 0;\n  user-select: none;\n}\n\n/* Main image area */\n.showcase-image {\n  flex: 1;\n  position: relative;\n  overflow: hidden;\n  background: #fafafa;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.main-product-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n/* Zoom button */\n.zoom-btn {\n  position: absolute;\n  top: 14px;\n  right: 14px;\n  width: 38px;\n  height: 38px;\n  background: white;\n  border: none;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.12);\n  z-index: 5;\n  transition: transform 0.2s;\n  color: #444;\n}\n\n.zoom-btn:hover { transform: scale(1.08); }\n\n/* Nav arrows */\n.image-navigation {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  right: 0;\n  transform: translateY(-50%);\n  display: flex;\n  justify-content: space-between;\n  padding: 0 14px;\n  z-index: 5;\n}\n\n.nav-btn {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.92);\n  border: none;\n  font-size: 1.6rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.12);\n  transition: all 0.2s;\n  color: #222;\n  line-height: 1;\n}\n\n.nav-btn:hover {\n  background: white;\n  transform: scale(1.08);\n}\n\n/* Dots */\n.image-dots {\n  position: absolute;\n  bottom: 14px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  gap: 6px;\n  z-index: 5;\n}\n\n.dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: rgba(0, 0, 0, 0.25);\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.dot.active {\n  background: #222;\n  width: 18px;\n  border-radius: 4px;\n}\n\n.showcase-icon {\n  font-size: 100px;\n  opacity: 0.3;\n}\n\n/* Frame styles */\n.frame-preview-container {\n  background: linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%);\n}\n\n.frame-with-photo {\n  width: 75%;\n  height: 80%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 12px solid #222;\n  box-shadow: inset 0 0 20px rgba(0,0,0,0.5), 0 10px 30px rgba(0,0,0,0.3);\n  position: relative;\n  border-radius: 4px;\n}\n\n.frame-photo-preview {\n  width: calc(100% - 40px);\n  height: calc(100% - 40px);\n  object-fit: cover;\n  border-radius: 2px;\n}\n\n/* ── RIGHT: Product Details ── */\n.product-details {\n  padding: 36px 36px 36px 36px;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n}\n\n.product-category-label {\n  display: block;\n  font-size: 0.82rem;\n  font-weight: 700;\n  color: #ed2b91;\n  margin-bottom: 10px;\n  letter-spacing: 0.3px;\n}\n\n.detail-title {\n  font-size: 2rem;\n  font-weight: 900;\n  color: #111;\n  margin: 0 0 12px;\n  line-height: 1.2;\n}\n\n.detail-description {\n  font-size: 0.92rem;\n  color: #666;\n  line-height: 1.65;\n  margin: 0 0 22px;\n}\n\n/* Features + Price side by side */\n.features-price-row {\n  display: flex;\n  gap: 16px;\n  align-items: flex-start;\n  margin-bottom: 24px;\n}\n\n.features-list {\n  flex: 1;\n}\n\n.features-list h3 {\n  font-size: 0.92rem;\n  font-weight: 800;\n  color: #111;\n  margin: 0 0 10px;\n}\n\n.features-list ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.features-list li {\n  font-size: 0.88rem;\n  color: #444;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding-left: 2px;\n}\n\n.features-list li::before {\n  content: '';\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #ed2b91;\n  flex-shrink: 0;\n}\n\n/* Price box */\n.price-box {\n  background: #f5f5f5;\n  border-radius: 14px;\n  padding: 16px 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  min-width: 130px;\n  flex-shrink: 0;\n}\n\n.price-label {\n  font-size: 0.8rem;\n  color: #999;\n  margin-bottom: 4px;\n  white-space: nowrap;\n}\n\n.price-value {\n  font-size: 2rem;\n  font-weight: 900;\n  color: #111;\n  line-height: 1;\n}\n\n.original-price-strike {\n  font-size: 0.85rem;\n  color: #bbb;\n  text-decoration: line-through;\n  margin-top: 4px;\n}\n\n/* ── Page Selection ── */\n.page-selection-inline {\n  margin-bottom: 20px;\n}\n\n.page-selection-title {\n  font-size: 0.92rem;\n  font-weight: 800;\n  color: #111;\n  margin: 0 0 12px;\n}\n\n.page-options-inline {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n}\n\n.page-option-btn {\n  background: white;\n  border: 1.5px solid #e2e2e2;\n  border-radius: 12px;\n  padding: 14px 16px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  transition: border-color 0.2s;\n  text-align: left;\n  font-family: \"Gilroy\", sans-serif;\n}\n\n.page-option-btn:hover { border-color: #ed2b91; }\n\n.page-option-btn.active {\n  border-color: #ed2b91;\n  border-width: 2px;\n}\n\n.option-radio-circle {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  border: 2px solid #ddd;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: border-color 0.2s;\n}\n\n.page-option-btn.active .option-radio-circle { border-color: #ed2b91; }\n\n.option-radio-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: #ed2b91;\n}\n\n.option-texts {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.option-label {\n  font-size: 0.88rem;\n  font-weight: 700;\n  color: #111;\n}\n\n.option-extra {\n  font-size: 0.8rem;\n  color: #888;\n}\n\n/* ── Design Button ── */\n.design-btn {\n  width: 100%;\n  background: #1a1a1a;\n  color: white;\n  border: none;\n  padding: 17px 24px;\n  border-radius: 14px;\n  font-size: 1rem;\n  font-weight: 700;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  transition: background 0.2s;\n  font-family: \"Gilroy\", sans-serif;\n  margin-top: 20px;\n  box-shadow: none;\n  height: auto;\n  max-width: 100%;\n}\n\n.design-btn:hover { background: #333; transform: none; }\n.design-btn:active { transform: none; }\n\n.add-to-cart-btn {\n  width: 100%;\n  background: white;\n  color: #1a1a1a;\n  border: 1.5px solid #1a1a1a;\n  padding: 15px 24px;\n  border-radius: 14px;\n  font-size: 1rem;\n  font-weight: 700;\n  cursor: pointer;\n  font-family: \"Gilroy\", sans-serif;\n  margin-top: 12px;\n  transition: background 0.2s, color 0.2s;\n}\n\n.add-to-cart-btn:hover { background: #1a1a1a; color: white; }\n\n.add-to-cart-btn:disabled {\n  background: #f0f0f0;\n  color: #909090;\n  border-color: #d4d4d4;\n  cursor: default;\n}\n\n.btn-arrow { font-size: 1.15rem; }\n\n/* Security text */\n.security-text {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  font-size: 0.82rem;\n  color: #999;\n  margin-top: 12px;\n}\n\n/* Kitchen note */\n.kitchen-personalization-note {\n  background: #f8f4ee;\n  border-left: 3px solid #2d3748;\n  padding: 12px 16px;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #2d3748;\n  font-weight: 500;\n  margin-bottom: 8px;\n}\n\n/* ── Upload sections ── */\n.upload-section {\n  margin-top: 20px;\n}\n\n.option-title {\n  font-size: 1rem;\n  font-weight: 700;\n  color: #111;\n  margin: 0 0 14px;\n}\n\n.frame-upload-section {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n}\n\n.frame-upload-btn {\n  background: #1a1a1a;\n  color: white;\n  padding: 13px 28px;\n  border-radius: 50px;\n  font-size: 0.92rem;\n  font-weight: 700;\n  cursor: pointer;\n  display: inline-block;\n  transition: background 0.2s;\n}\n\n.frame-upload-btn:hover { background: #333; }\n\n.upload-hint {\n  font-size: 0.82rem;\n  color: #aaa;\n  margin: 0;\n}\n\n.order-btn {\n  width: 100%;\n  background: #1a1a1a;\n  color: white;\n  border: none;\n  padding: 17px 24px;\n  border-radius: 14px;\n  font-size: 1rem;\n  font-weight: 700;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  transition: background 0.2s, transform 0.2s;\n  font-family: \"Gilroy\", sans-serif;\n  margin-top: 20px;\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.18);\n}\n\n.order-btn:hover:not(:disabled) { background: #333; }\n.order-btn:active:not(:disabled) { transform: scale(0.98); }\n\n/* Uploaded images */\n.uploaded-images { margin-top: 20px; }\n\n.uploaded-images h4 {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: #111;\n  margin: 0 0 14px;\n}\n\n.images-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\n  gap: 10px;\n}\n\n.image-preview {\n  position: relative;\n  border-radius: 10px;\n  overflow: hidden;\n  background: #f5f5f5;\n}\n\n.image-preview img {\n  width: 100%;\n  height: 110px;\n  object-fit: cover;\n  display: block;\n}\n\n.remove-image-btn {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  background: rgba(0, 0, 0, 0.55);\n  color: white;\n  border: none;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 0.75rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.2s;\n}\n\n.remove-image-btn:hover { background: rgba(0, 0, 0, 0.8); }\n\n.image-name {\n  padding: 6px 8px;\n  font-size: 0.72rem;\n  color: #666;\n  background: white;\n  text-align: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* ── Customization / Related Products ── */\n.customization-section {\n  background: white;\n  border-radius: 20px;\n  padding: 36px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);\n}\n\n.section-heading {\n  font-size: 1.8rem;\n  font-weight: 900;\n  color: #111;\n  margin: 0 0 30px;\n  text-align: center;\n}\n\n.option-group { margin-bottom: 30px; }\n\n.book-store-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 18px;\n  margin-top: 16px;\n}\n\n.book-card {\n  background: white;\n  border: 1px solid #ebebeb;\n  border-radius: 12px;\n  overflow: hidden;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  flex-direction: column;\n}\n\n.book-card:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.1);\n}\n\n.book-image-container {\n  width: 100%;\n  height: 240px;\n  /* background: #f5f5f5; */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  position: relative;\n}\n\n.book-image {\n  width: 160px;\n  height: auto;\n  object-fit: cover;\n  transition: transform 0.3s;\n}\n\n.book-card:hover .book-image { transform: scale(1.05); }\n\n.book-placeholder { font-size: 50px; opacity: 0.25; }\n\n.book-discount-badge {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  background: #ed2b91;\n  color: white;\n  font-size: 0.72rem;\n  font-weight: 700;\n  padding: 4px 10px;\n  border-radius: 20px;\n}\n\n.book-info {\n  padding: 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  flex-grow: 1;\n}\n\n.book-title {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: #111;\n  margin: 0;\n  line-height: 1.3;\n}\n\n.book-subtitle {\n  font-size: 0.82rem;\n  color: #888;\n  margin: 0;\n  line-height: 1.3;\n}\n\n.book-pricing {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.book-current-price {\n  font-size: 1.15rem;\n  font-weight: 900;\n  color: #111;\n}\n\n.book-original-price {\n  font-size: 0.82rem;\n  color: #bbb;\n  text-decoration: line-through;\n}\n\n.book-discount-label {\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: #ed2b91;\n  background: rgba(237, 43, 145, 0.08);\n  padding: 2px 7px;\n  border-radius: 10px;\n}\n\n.book-details-btn {\n  width: 100%;\n  background: #1a1a1a;\n  color: white;\n  border: none;\n  padding: 10px 14px;\n  border-radius: 8px;\n  font-weight: 700;\n  font-size: 0.8rem;\n  cursor: pointer;\n  transition: background 0.2s;\n  letter-spacing: 0.5px;\n  margin-top: auto;\n}\n\n.book-details-btn:hover { background: #333; }\n\n/* ── Not found ── */\n.not-found {\n  text-align: center;\n  padding: 100px 20px;\n  font-size: 1.5rem;\n  color: #888;\n}\n\n/* ── Animations ── */\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(16px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n/* ── Responsive: Tablet ── */\n@media (max-width: 900px) {\n  .product-detail-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .product-showcase {\n    border-right: none;\n    border-bottom: 1px solid #f0f0f0;\n    height: 400px;\n  }\n\n  .thumbnails-col {\n    width: 76px;\n    padding: 14px 8px 14px 12px;\n  }\n\n  .thumbnail {\n    width: 56px;\n    height: 56px;\n  }\n\n  .product-details {\n    padding: 28px 24px;\n  }\n\n  .detail-title { font-size: 1.6rem; }\n  .price-value { font-size: 1.7rem; }\n}\n\n/* ── Responsive: Mobile ── */\n@media (max-width: 640px) {\n  .detail-container {\n    padding: 0 0 40px;\n  }\n\n  /* Product card flush to edges on mobile */\n  .pd-card {\n    border-radius: 0;\n    box-shadow: none;\n    border-bottom: 1px solid #e8e8e8;\n    margin-bottom: 16px;\n  }\n\n  /* Stack: image on top, thumbnails horizontal below */\n  .product-showcase {\n    flex-direction: column;\n    height: auto;\n    border-bottom: 1px solid #f0f0f0;\n  }\n\n  /* Main image area */\n  .showcase-image {\n    width: 100%;\n    height: 300px;\n    background: #fff;\n  }\n\n  /* Image fits fully without cropping */\n  .main-product-image {\n    object-fit: contain;\n    padding: 35px;\n  }\n\n  /* Thumbnails become horizontal strip below image */\n  .thumbnails-col {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    height: auto;\n    padding: 10px 14px;\n    border-right: none;\n    border-top: 1px solid #f2f2f2;\n    overflow-x: auto;\n    overflow-y: visible;\n    gap: 8px;\n  }\n\n  .thumbnail {\n    width: 58px;\n    height: 58px;\n    flex-shrink: 0;\n  }\n\n  /* Details section */\n  .product-details {\n    padding: 22px 18px 28px;\n  }\n\n  .product-category-label {\n    font-size: 0.8rem;\n    margin-bottom: 6px;\n  }\n\n  .detail-title {\n    font-size: 1.55rem;\n    margin-bottom: 10px;\n  }\n\n  .detail-description {\n    font-size: 0.88rem;\n    margin-bottom: 18px;\n  }\n\n  /* Features + Price stack vertically */\n  .features-price-row {\n    flex-direction: column;\n    gap: 14px;\n    margin-bottom: 20px;\n  }\n\n  .features-list h3 {\n    font-size: 0.9rem;\n    margin-bottom: 8px;\n  }\n\n  .features-list li {\n    font-size: 0.86rem;\n  }\n\n  /* Price box full width */\n  .price-box {\n    align-items: flex-start;\n    width: 100%;\n    padding: 14px 16px;\n    flex-direction: row;\n    align-items: center;\n    gap: 12px;\n  }\n\n  .price-label {\n    font-size: 0.82rem;\n    margin-bottom: 0;\n  }\n\n  .price-value {\n    font-size: 1.8rem;\n  }\n\n  /* Page selection */\n  .page-selection-title {\n    font-size: 0.9rem;\n    margin-bottom: 10px;\n  }\n\n  .page-options-inline {\n    grid-template-columns: 1fr;\n    gap: 8px;\n  }\n\n  .page-option-btn {\n    padding: 13px 14px;\n  }\n\n  .option-label { font-size: 0.88rem; }\n  .option-extra { font-size: 0.78rem; }\n\n  /* Design button */\n  .design-btn {\n    padding: 16px 20px;\n    font-size: 0.97rem;\n    border-radius: 12px;\n    margin-top: 16px;\n  }\n\n  .order-btn {\n    padding: 16px 20px;\n    font-size: 0.97rem;\n    border-radius: 12px;\n    margin-top: 16px;\n  }\n\n  .security-text {\n    font-size: 0.8rem;\n    margin-top: 10px;\n  }\n\n  /* Nav arrows smaller on mobile */\n  .nav-btn {\n    width: 34px;\n    height: 34px;\n    font-size: 1.3rem;\n  }\n\n  /* Customization section */\n  .customization-section {\n    border-radius: 0;\n    padding: 24px 16px;\n    box-shadow: none;\n  }\n\n  .section-heading {\n    font-size: 1.3rem;\n    margin-bottom: 20px;\n  }\n\n  .book-store-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 10px;\n  }\n\n  .book-image-container { height: 160px; }\n\n  .book-image { width: 120px; }\n\n  .book-info { padding: 10px; gap: 4px; }\n\n  .book-title { font-size: 0.85rem; }\n\n  .book-subtitle { font-size: 0.75rem; }\n\n  .current-price { font-size: 1rem; }\n\n  .book-details-btn {\n    font-size: 0.75rem;\n    padding: 8px 10px;\n  }\n\n  /* Upload section */\n  .frame-upload-btn {\n    padding: 12px 22px;\n    font-size: 0.88rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
